// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b2c68864","396":"4f144acc","455":"cd6be074","977":"13ded8fb"}[chunkId] + ".chunk.js";
};